import axios from "axios";
import { UserDataResponse } from "../interfaces/responseModels";

export const fetchUserData = (accessToken: string) =>
  axios.get<UserDataResponse>(`api/v1/user/me`, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
